import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";

const StudentRules = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <Typography variant="h6" align="center" gutterBottom>
        En suivant les cours dans l'institut Al-Ansarr l'élève s'engage a suivre
        les règles suivantes:
      </Typography>

      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          Respecter notre religion
        </Typography>
        <Typography variant="body1">
          Aucun propos injurieux envers notre Seigneur, notre religion, la
          sunnah de notre prophète bien aimé, les savants de la sunnah et tout
          ce qui s'y rattache n'est accepté et sera soumis à une exclusion
          immédiate de l'élève.
        </Typography>
      </Box>

      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          Règle n°1 : S'exprimer comme il convient avec son professeur et le
          respecter
        </Typography>
        <Typography variant="body1">Pas de wesh wesh.</Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          Règle n°2 : Être sérieux
        </Typography>
        <Typography variant="body1">
          L'étudiant doit s'investir dans ces cours, être attentifs pendant les
          cours, poser des questions lorsqu'il ne comprend pas, faire ce qui lui
          est demandé par le professeur à la maison.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          Règle n°3 : Tenue et comportement
        </Typography>
        <Typography variant="body1">
          Une tenue vestimentaire décente est exigée. Bien que le cours ait lieu
          sur Zoom, les élèves doivent s'habiller de manière appropriée et
          respectueuse.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          Règle n°4 : Assidu
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="En cas d'absence ou de retard l'élève doit se justifier auprès de son professeur" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Si l'élève s'absente pour une raison acceptable il doit prévenir son professeur 12 heures avant le cours, dans ce cas le professeur lui donnera ses disponibilités de la semaine pour rattraper l'heure dans le cas contraire aucune proposition de rattrapage sera donnée à lélève." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Si l'élève est en retard sans avoir prévenu à l'avance, le professeur attendra 5 minutes, puis il quittera la réunion et dans ce cas le cours n'aura pas lieu, sauf si la raison que l'élève avance est jugée acceptable. L'ELEVE NE SERA PAS REMBOURSE POUR CETTE HEURE." />
          </ListItem>
        </List>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          Règle n°5 : L'environnement et l'usage du matériel.
        </Typography>
        <Typography variant="body1">
          L'élève doit être dans un environnement adequate c'est à dire pas de
          bruit de fond qui peut être dérrangeant aussi bien pour l'élève que le
          professeur et le bon déroulement du cours. <br /> L'élève doit
          s'assurer que son matériel (ordinateur, connexion internet, etc.) est
          en bon état de fonctionnement pour suivre les cours sans interruption.
          En cas de problème technique, il doit en informer son professeur dès
          que possible.
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          Règle n°6 : Respect de la confidentialité des livres mis à disposition
        </Typography>
        <Typography variant="body1">
          Ce qui est fourni dans les livres l'étudiant ne doit pas être partagé,
          copié ou distribué sans l'autorisation de l'institut sans
          l'approbation du directeur. Toute violation de cette règle sera
          considérée comme une infraction grave.
        </Typography>
      </Box> */}

      <Typography variant="body1">
        NOTE IMPORTANTE: Si le professeur juge que l'élève ne respecte pas les
        règles comportementales il pourra se séparer de l'élève et les cours qui
        restent à l'élève dont il n'a pas pu profiter lui seront remboursés.
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Box mt={4} mb={5}>
        <Typography variant="h5" gutterBottom>
          Règle n°6 : Acceptation du règlement
        </Typography>
        <Typography variant="body1">
          L'élève reconnaît avoir pris connaissance du présent Règlement
          Intérieur et s'engage à le respecter.
        </Typography>
      </Box>
    </Container>
  );
};

export default StudentRules;
